"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    width: 100%;\n    position: relative;\n    // + pointer icon offset\n    padding: 10px 0;\n    box-sizing: content-box;\n    ", ";\n    &:after {\n        content: '';\n        display: block;\n        width: 100%;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: 0;\n        z-index: 1;\n        ", ";\n    }\n    &:hover {\n        cursor: pointer;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme;
  return {
    height: theme.height
  };
};

var after = function after(_ref2) {
  var theme = _ref2.theme;
  return {
    height: theme.height,
    background: theme.background,
    borderRadius: theme.borderRadius
  };
};

var Progress = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
}, function (props) {
  return after(props);
});

var _default = Progress;
exports["default"] = _default;